
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const ButacoPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#e8f0ef',
            100: '#c5d9d6',
            200: '#9ebfbb',
            300: '#77a5a0',
            400: '#59918b',
            500: '#3b7e77',
            600: '#2d6b64',
            700: '#1F5C4A',
            800: '#164B41',
            900: '#0e3f38',
            950: '#082a25'
        },
        colorScheme: {
            light: {
                primary: {
                    color: '#164B41',
                    inverseColor: '#ffffff',
                    hoverColor: '#0e3f38',
                    activeColor: '#164B41'
                },
            }
        }
    }
});